// extracted by mini-css-extract-plugin
export var disabled = "_x-a";
export var hierarchyLinkGray = "_x-4";
export var hierarchyLinkUnderline = "_x-3";
export var hierarchyPrimary = "_x-0";
export var hierarchySecondary = "_x-1";
export var hierarchyTertiary = "_x-2";
export var pressed = "_x-6";
export var themeAction = "_x-5";
export var themeDestructive = "_x-8";
export var themeNormal = "_x-7";
export var themeSuccess = "_x-9";